import { render, staticRenderFns } from "./VOCcomReport.vue?vue&type=template&id=1d740354&scoped=true&"
import script from "./VOCcomReport.vue?vue&type=script&lang=js&"
export * from "./VOCcomReport.vue?vue&type=script&lang=js&"
import style0 from "./VOCcomReport.vue?vue&type=style&index=0&id=1d740354&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d740354",
  null
  
)

export default component.exports